module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/085c5eb3b205117750cc64925b74a284.png";